
const useUrlBasica = () => {
    return process.env.REACT_APP_URL_BASICA || '';
}

export default useUrlBasica;